module.exports = __webpack_public_path__ + "static/media/users.5840c132.svg";